export const JPA_API_URL = process.env.NODE_ENV === 'production'
    ? 'https://cloudzenyth.ddns.net/api'
    : 'http://localhost:5000'